import { SvgType } from './types'

export default function Actions({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.86969 11.9466C6.15555 11.2692 3.29992 11.0509 2.44165 11C2.32584 11 2.21499 11.0342 2.13085 11.1125C2.0475 11.1917 2 11.3017 2 11.4158V19.7494C2 19.9794 2.18667 20.1661 2.41665 20.1661H4.91649C5.09648 20.1661 5.25647 20.0503 5.31229 19.8786C5.3731 19.6919 6.80887 14.4515 6.998 12.2849C7.00886 12.1591 6.96218 12.0341 6.86969 11.9466Z"
        fill={fill}
      />
      <path
        d="M19.4995 16.4229L16.583 17.6678C15.7756 17.707 14.0965 17.6545 13.6665 17.6603C13.2432 17.6661 11.0792 16.972 11.4183 16.8345C11.4892 16.8053 11.67 16.7995 12 16.827C13.9032 16.9853 16.9997 17.3687 16.9997 15.9937C16.9997 14.6188 13.6441 14.3272 12.8333 14.3272C12.0224 14.3272 10.6634 13.5997 9.50015 13.4939C9.03768 13.4522 8.40272 13.3889 7.75776 13.3489C7.49446 15.1404 6.72701 17.7369 6.33203 19.0068L10.7501 21.0051C12.4033 21.63 13.5274 22.4283 16.9997 21.0051C16.9997 21.0051 21.9993 18.8827 21.9993 17.672C21.9993 16.6712 20.8536 15.9545 19.4995 16.4229Z"
        fill={fill}
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M15.4 5.7a.738.738 0 01-.183-.251.685.685 0 01-.057-.298c0-.22.077-.409.24-.55a.884.884 0 01.6-.22c.24 0 .446.07.6.22.154.149.24.33.24.55 0 .22-.077.408-.24.55a.897.897 0 01-.6.235.845.845 0 01-.6-.235zm1.457 1.808a.824.824 0 00-.266-.542.916.916 0 00-.591-.244h-.857a1.03 1.03 0 00-.592.244.773.773 0 00-.265.542h.857v2.357a.761.761 0 00.266.542c.171.157.36.244.591.244h.857c.232 0 .412-.087.592-.244a.731.731 0 00.265-.542h-.857V7.5v.008zM16 3.038c-2.691 0-4.886 1.995-4.886 4.462 0 2.467 2.195 4.479 4.886 4.479 2.691 0 4.886-2.004 4.886-4.479S18.69 3.03 16 3.03v.007zM16 2c3.309 0 6 2.467 6 5.5S19.309 13 16 13s-6-2.451-6-5.5S12.691 2 16 2z"
        clipRule="evenodd"
      />
    </svg>
  )
}
